// extracted by mini-css-extract-plugin
module.exports = {"btn":"selectButton_btn__3l3uB","fadeIn":"selectButton_fadeIn__L3bMx"};